
import Vue from "vue";
import vModal from "@/components/vModal.vue";
import { REPORT_NOTIFICATION_CLEAR } from "@/store/ActionTypes";
import { mapState } from "vuex";

export default Vue.extend({
  components: {
    vModal,
  },
  computed: {
    ...mapState({
      reportNotification: (state: any) => state.ReportNotificationModule,
    }),
  },

  provide() {
    return {
      validator: this.$validator
    };
  },
  methods: {
    clearReportNotification() {
      this.$store.dispatch(REPORT_NOTIFICATION_CLEAR);
    },
  },
  created() {
    this.$snotify.config.global = {
      maxOnScreen: 5,
      preventDuplicates: true,
    };
  },

  mounted() {
    if (navigator.appVersion.indexOf("Windows NT 6.2") != -1) {
      document.head.innerHTML +=
        '<link rel="stylesheet" type="text/css" href="pages/css/windows.chrome.fix.css" />';
    }
  }
});
